"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pquot = void 0;
var intBinOpToInt_1 = require("./intBinOpToInt.js");
var IRNative_1 = require("../../../../IR/IRNodes/IRNative/index.js");
exports.pquot = (0, intBinOpToInt_1.intBinOpToInt)(IRNative_1.IRNative.quotientInteger);
